export const getters = {
    getTokenLaravel: (state) => state.tokenLaravel,
    getShowMenu: (state) => state.showMenu,
    getUser: (state) => state.user
};